import React from 'react';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import type { User } from '../models/user';

type Props = {
  user: User | null | undefined;
  onEdit?: () => void;
};

const UserProfileCard: React.FC<Props> = ({ user, onEdit }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          User Profile
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Name: {user?.name || 'Not set'}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          ID: {user?.id}
        </Typography>
        {onEdit && (
          <Box sx={{ mt: 1 }}>
            <Button variant="outlined" size="small" onClick={onEdit}>
              Edit profile
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default UserProfileCard;

